import { lockInit, triggerInitIfReleased, unlockInit } from "./init/defer.js";
import { initPdpWorkaround, isPdpWorkaroundEnabled } from "./special/pdpWorkaround.js";
import { initDataTracker } from "./init/init.js";
import { onLoad } from "@gr-exports/async/dom";
import { tracking } from "@gr-exports/async/tracking";
import { defineEvent } from "@gr-exports/async/nexus";

/*                                                                   */
/*                                                           */
initDataTracker();

/*                                                               */
/*                                                                   */
/*                                                                */

/*                                                                           */
if (isPdpWorkaroundEnabled()) {
  /*                                            */
  /*                                    */
  initPdpWorkaround(triggerInitIfReleased);
} else {
  /*                                                              */
  onLoad.subscribe(triggerInitIfReleased);
}

export default tracking.assignNamespace(
  {
    lockInit,
    unlockInit,
    onInit: defineEvent(),
  },
  { lock: import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true" },
);
